<section fxFlex="auto" fxLayout="column" class="countrypagebg">

    <mat-progress-bar class="iwg-navbar-progress" color="accent" mode="indeterminate" *ngIf="this.isLoading"></mat-progress-bar>

    <div fxFlex="auto" class="iwg-country-guide content">

        <div fxLayout="row" [ngClass]="{'iwg-country-guide-title-embed': embedStatus === 'embed', 'iwg-country-guide-title' : embedStatus === 'notembed' }">
            These guides provide
            country-specific information regarding employment policies and practices relevant to managing a
            global workforce.
        </div>

        <div fxLayoutAlign="center center" fxLayout="row" class="vista-countryguide">
            <div [ngClass]="{'iwg-country-guide-title-embed': embedStatus === 'embed', 'iwg-country-guide-title' : embedStatus === 'notembed' }">MyGuides</div>
            <span fxFlex></span>
            <mat-form-field class="vista-countryguide" style="width: 200px; margin: 8px 12px;">
                <input [(ngModel)]="filter" matInput type="text" (input)="search($event.target.value)" placeholder="Search...">
                <mat-icon class="ico-inside-input">search</mat-icon>
            </mat-form-field>
        </div>

        <mat-grid-list class="iwg-country-grid" [cols]="cols" rowHeight="172px" gutterSize="40px">
            <mat-grid-tile *ngFor="let countryGuide of countryGuides" class="iwg-country-card pointer-cursor" [ngStyle]="{'background-image':'url' +'(' + countryGuide.ImageURL +')','background-size':'cover'}"
                           [routerLink]="['/countryGuideDetail',countryGuide.ID]"
                           (click)="this.selectedCountryGuide = countryGuide">
                <mat-grid-tile-header>
                    {{countryGuide.CountryTitle}}
                </mat-grid-tile-header>
            </mat-grid-tile>
        </mat-grid-list>

    </div>
    <div *ngIf="showFooter" class="innerpage-footer">
        <app-iwg-footer [blurBg]="true"></app-iwg-footer>
    </div>
</section>
